export default __webpack_public_path__ + "static/media/JaniceFenech.7c413aa7.webp";